import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  show(e) {
    const el = document.getElementById('prebannerBtn')
    if (el) { el.click() }
  }
}
